<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar-menu></sidebar-menu>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title + ' - ' + namaCompany" :title1="title1" />

        <!-- /add -->
        <div class="card">
          <div class="card-body">
            <!-- <Form @submit="update" :validation-schema="schema" v-slot="{ errors }"> -->
            <form @submit.prevent="insert">
              <div class="row">
                <div class="col-lg-12 col-sm-6 col-12">
                  <div class="form-group">
                    <div class="d-flex justify-content-between ">
                      <label>Employee <span class="text-danger">*</span></label>
                    </div>
                    <!-- <model-select :options="data_marketing" placeholder="Select Marketing"
                      v-model="this.currentData.id_marketing" style="z-index:500" :isError="marketingCek">
                    </model-select> -->
                    <multi-select :options="needData1" :selected-options="employees" style="z-index:504"
                      placeholder="select Employee" @select="onSelectEmployees">
                    </multi-select>
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Date <span class="text-danger">*</span></label>
                    <div class="input-groupicon" style="z-index: 100;">
                      <datepicker v-model="currentData.tanggal" class="picker" :editable="true" :clearable="false"
                        required />
                      <a class="addonset">
                        <img src="../../../assets/img/icons/calendars.svg" alt="img" />
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Shift <span class="text-danger">*</span></label>
                    <div class="input-groupicon" style="z-index: 100;">
                      <!-- <datepicker v-model="currentData.shift" class="picker" :editable="true" :clearable="false"
                        required />
                      <a class="addonset">
                        <img src="../../../assets/img/icons/calendars.svg" alt="img" />
                      </a> -->
                      <model-select :options="needData2" :settings="{ settingOption: value, settingOption: value }"
                              v-model="currentData.shift_id" class="custom-width form-control" placeholder="" ></model-select>
                    </div>
                  </div>
                </div>

                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Clock in<span class="text-danger">*</span></label>
                    <input type="time" id="jam_masuk" name="jam_masuk" v-model="currentData.jam_masuk">
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Clock out<span class="text-danger">*</span></label>
                    <input type="time" id="jam_keluar" name="jam_keluar" v-model="currentData.jam_keluar">
                  </div>
                </div>

                <!-- <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <div class="d-flex justify-content-between ">
                      <label>Employee <span class="text-danger">*</span></label>
                    </div>
                    <multi-select :options="needData1" :selected-options="employees" style="z-index:504"
                      placeholder="select Employee" @select="onSelectEmployees">
                    </multi-select>
                  </div>
                </div> -->
                <div class="col-lg-12">
                  <button type="submit" class="btn btn-submit me-2">Save</button>
                  <router-link to="schedule" class="btn btn-cancel">Cancel</router-link>
                </div>
              </div>

            </form>
          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>
</template>

<style scoped>
.form-group input[type="datetime-local"] {
  border: 1px solid rgba(145, 158, 171, 0.32);
  height: 40px;
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  color: #637381;
  padding: 10px 15px;
  border-radius: 5px;
}

.form-group input[type="time"] {
  border: 1px solid rgba(145, 158, 171, 0.32);
  height: 40px;
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  color: #637381;
  padding: 10px 15px;
  border-radius: 5px;
}

.form-group input[type="datetime-local"]:focus {
  border: 1px solid rgba(82, 183, 127, 255);

}

.form-group input[type="time"]:focus {
  border: 1px solid rgba(82, 183, 127, 255);

}
</style>

<script>
import Cookies from "js-cookie";
import axios from "axios";
import { base_url, AlertPopup2, goPage, AlertBottom, appendForm, timeout, selectedBranch } from "@/assets/js/function";
import { ModelSelect, MultiSelect } from 'vue-search-select';
// import { watch } from "vue";


export default {
  components: {

    ModelSelect,
    MultiSelect

  },
  name: "editemployee",
  data() {
    return {
      filter: true,
      title: "Insert Schedule",
      title1: "add new schedule",
      namaCompany: '',
      config: "",
      api: "",
      value: "",

      //data
      currentData: {
        tanggal: new Date(),
        shift_id: null,
        jam_masuk: '',
        jam_keluar: '',

      },
      currentDate: new Date,
      needData1: [],
      needData2: [],

      ///multi select
      locations: [],
      employees: [],

      lastSelectItemLocation: {},
      lastSelectItemEmployee: {},
    };
  },

  async created() {
    const token = Cookies.get("token_refresh");
    this.config = {
      headers: {
        Authorization: `Bearer ` + token,
      },
      timeout: 30000,
    }
    
    const branch = parseInt(localStorage.getItem("selectedBranch")) || 0;

    //Update local and shared state
    this.filter = branch;
    selectedBranch.value = branch;

    this.namaCompany = localStorage.getItem('namaCompany');

    localStorage.setItem('actionState', 'insert')


    // this.getEmployees();
    // this.getShift();
    this.preparedData();

  },

  // mounted() {
  //   watch(selectedBranch, () => {
  //       this.index()
  //   }, { immediate: true })
  // },

  watch: {
    "currentData.shift_id"(newIdShift) {
      // Find the selected shift's jam_masuk from needData2
      const selectedShift = this.needData2.find(
        (item) => item.value === newIdShift
      );
      if (selectedShift) {
        // Update the clock-in time with the selected shift's jam_masuk
        // this.currentData.jam_masuk = selectedShift.text.match(/\(([^-]*)/)[1].trim(); // Extracts jam_masuk
        
        const shiftTimes = selectedShift.text.match(/\(([^-]*) - ([^)]*)\)/);
        if (shiftTimes) {
          this.currentData.jam_masuk = shiftTimes[1].trim(); // Set jam_masuk
          this.currentData.jam_keluar = shiftTimes[2].trim(); // Set jam_keluar
        }
      }
    },
  },
  
  methods: {

    preparedData() {
      const needData1 = JSON.parse(localStorage.getItem('employeeList'));
      needData1.forEach((item, index) => {
        const item_prepare = { value: item.id, text: item.nama + ' (' + item.telepon + ')' };
        this.needData1.push(item_prepare);
      });

      const needData2 = JSON.parse(localStorage.getItem('shiftList'));
      needData2.forEach((item, index) => {
        const item_prepare = { value: item.id, text: item.nama_shift + ' (' + item.jam_masuk + ' - ' +  item.jam_pulang + ')'  };
        this.needData2.push(item_prepare);
      });
    },
    
    onSelectLocations(items, lastSelectItem) {
      this.locations = items
      this.lastSelectItemLocation = lastSelectItem
    },
    onSelectEmployees(items, lastSelectItem) {
      this.employees = items
      this.lastSelectItemEmployee = lastSelectItem
    },
    getNameFileUrl(url) {
      const parts = url.split('/');
      const fileName = parts[parts.length - 1];
      return fileName;
    },

    formatDateLocaly(dateInput) {
      const dateObj = new Date(dateInput);
      if (isNaN(dateObj.getTime())) return null; // Invalid date check

      const year = dateObj.getFullYear();
      const month = ('0' + (dateObj.getMonth() + 1)).slice(-2);
      const day = ('0' + dateObj.getDate()).slice(-2);
      return `${year}-${month}-${day}`;
    },

    async insert() {
      
      let formData = new FormData();
      appendForm(formData)

      Object.entries(this.currentData).forEach(([key, value]) => {
        formData.append(key, value);
      });

      formData.delete("tanggal");
      formData.append("tanggal", this.formatDateLocaly(this.currentData.tanggal));

      let employee_id = [];
      this.employees.forEach((item, index) => {
        employee_id.push(item.value)
      });
      formData.append('employee_id', employee_id.join(','));


      for (let [key, value] of formData.entries()) {
        console.log(`${key}: ${value}`);
      }
      // CloseLoading();
      // return false;

      const api = base_url + '/v3/schedule/insert';
      const res = await axios.post(api, formData, { timeout });
      const data = res.data;
      
      if(data.status){
        AlertBottom(data.message);
        goPage('schedule');
      }else {
        AlertPopup2("error", "", data.message, true, 1500);
      }

      
    },

    // getEmployees() {
    //     ShowLoading();
    //     let formData = new FormData();

    //     if (!this.filter) {
    //       const savedBranch = localStorage.getItem("selectedBranch");
    //       this.filter = savedBranch !== null ? savedBranch : 0;
    //     }
    //     formData.append("filter", this.filter == 0 ? '' : this.filter);
    //     this.api = base_url + 'employees/index';
    //     axios.post(this.api, formData, this.config)
    //       .then((response) => {
    //         if (response.data.status == true) {
    //           // localStorage.setItem('needData1', JSON.stringify(response.data.data));
    //           this.needData1 = response.data.data.map((item) => {
    //               return { 
    //                   value: item.id, 
    //                   text: item.nama + ' (' + item.telepon + ')' 
    //               };
    //           });

    //           CloseLoading();
    //         } else {
    //           AlertPopup("error", "", response.data.message, 1500, false);
    //         }
    //       })
    //       .catch((error) => {
    //         ErrorConnectionTimeOut(error);
    //       });
    // },

    // getShift() {
    //     ShowLoading();
    //     let formData = new FormData();
    //     appendForm(formData);

    //     this.api = base_url + 'v3/shift/index';
    //     axios.post(this.api, formData, this.config)
    //       .then((response) => {
    //         console.log("ini data shift", response.data.data);
    //         if (response.data.status == true) {
    //           this.needData2 = response.data.data.shift.map((item) => {
    //               return { 
    //                   value: item.id, 
    //                   text: item.nama_shift + ' (' + item.jam_masuk + ' - ' + item.jam_pulang + ')' 
    //               };
    //           });

    //           CloseLoading();
    //         } else {
    //           AlertPopup("error", "", response.data.message, 1500, false);
    //         }
    //       })
    //       .catch((error) => {
    //         ErrorConnectionTimeOut(error);
    //       });
    // },

  }
  

  }

</script>
